export default "__VITE_ASSET__C8GmzE5B__"